<template>
  <Main :data="data" @remove="(row) => $emit('remove', row)">
    <template #header>
      <div class="d-flex align-items-center justify-content-end">
        <div class="selector-selected-number">
          <span>{{ $l('tips_selector_selected') || '已选' }}</span>
          <span class="mx-2">{{ count }}</span>
          <span>{{ $l('tips_selector_selected_person') || '人' }}</span>
        </div>
        <div v-if="count" class="ml-3">
          <el-button
            type="text"
            size="medium"
            class="p-0"
            @click="$emit('clear')"
          >
            {{ $l('btn_clear') || '清空' }}
          </el-button>
        </div>
      </div>
    </template>
  </Main>
</template>

<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: { data: { type: Array, default: () => [] } },
  computed: {
    count() {
      return this.data?.length || 0
    },
  },
}
</script>

<style lang="scss" scoped>
.selector-selected-number {
  color: #071437;
  font-size: 14px;
  span:first-child {
    color: #8f97ad;
  }
  span:last-child {
    color: #8f97ad;
  }
}
</style>
